// extracted by mini-css-extract-plugin
export default {"input":"Input_input__VctAn","block":"Input_block__r4U-h","small":"Input_small__co8HW","medium":"Input_medium__CgiSQ"};